import * as React from "react";

const PauseIconBlue = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" {...props}>
    <path
      fill="#3B82F6"
      d="M11.5 1v10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1ZM4 0H1.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1H4a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Z"
    />
  </svg>
);

export default PauseIconBlue;
